import React from 'react';
import { getStrengthRecommendation } from '@/utils/decisionState';

/**
 * Bloque "Recomendaciones de fuerza" — condicional por escenario del motor.
 *
 * - Verde / amarillo claro / amarillo → tabla 3 columnas × 2 filas + nota.
 * - Naranja / rojo → solo caja con mensaje de diferimiento.
 *
 * Se monta en Step 7 del wizard y en la pantalla individual de detalle.
 * El PDF profesional/alumno tiene su propio renderer espejo en pdf_generator.py.
 */
export default function StrengthBlock({ estado, className = '' }) {
  const rec = getStrengthRecommendation(estado);

  if (!rec.showTable) {
    return (
      <div
        className={`p-4 rounded-lg border ${rec.bannerClasses} ${className}`}
        data-testid="strength-deferred"
      >
        <p className="text-sm font-medium font-['Inter']">
          {rec.deferredMessage}
        </p>
      </div>
    );
  }

  return (
    <div className={className} data-testid="strength-table">
      {/* Dos columnas fijas: en la columna angosta de la derecha, tres no
          entraban y las etiquetas se partían a la mitad ("FRECUENCI A"). */}
      <div className="grid grid-cols-2 gap-2.5">
        {rec.rows.map(([label, value]) => (
          <div
            key={label}
            className={`rounded-xl border ${rec.bannerClasses} px-3 py-2.5`}
          >
            <p
              className={`text-[10px] uppercase tracking-wide font-semibold ${rec.labelClasses} mb-0.5 font-['Inter'] whitespace-nowrap overflow-hidden text-ellipsis`}
            >
              {label}
            </p>
            <p className="text-sm font-bold font-['Inter'] leading-snug">{value}</p>
          </div>
        ))}
      </div>
      {rec.note && (
        <p
          className="mt-3 text-xs italic text-slate-500 font-['Inter']"
          data-testid="strength-note"
        >
          {rec.note}
        </p>
      )}
    </div>
  );
}
